import { cn } from "@/lib/utils"

interface LogoProps {
  variant?: "main" | "esim" | "remittance"
  size?: "sm" | "md" | "lg"
  showText?: boolean
  className?: string
}

const sizeClasses = {
  sm: "h-6 w-6 text-sm",
  md: "h-8 w-8 text-xl",
  lg: "h-10 w-10 text-4xl",
}

const radiusClasses = {
  sm: "rounded-xl",
  md: "rounded-xl",
  lg: "rounded-xl",
}

const textSizeClasses = {
  sm: "text-lg",
  md: "text-xl",
  lg: "text-4xl",
}

const variantClasses = {
  main: "bg-primary text-primary-foreground",
  esim: "bg-esim text-esim-foreground",
  remittance: "bg-remittance text-remittance-foreground",
}

export function Logo({ variant = "main", size = "md", showText = true, className }: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div
        className={cn(
          "flex items-center justify-center font-semibold transition-colors",
          sizeClasses[size],
          radiusClasses[size],
          variantClasses[variant]
        )}
      >
        M
      </div>
      {showText && (
        <span className={cn(
          "font-sans font-semibold tracking-[-0.03em] text-foreground",
          textSizeClasses[size]
        )}>
          Monra
          {variant !== "main" && (
            <span className={cn(
              "ml-1 text-sm font-semibold",
              variant === "esim" ? "text-esim-deep" : "text-remittance-deep"
            )}>
              {variant === "esim" ? "eSIM" : "Remittance"}
            </span>
          )}
        </span>
      )}
    </div>
  )
}
